<template>
  <!--左侧产品搜索结果菜单 -->
  <div class="leftlist">
    <div class="left-toolbar" style="height:80%; width:100%" v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0.5)" v-show="loading">

    </div>
    <div class="left-toolbar" style="height:60%; overflow-Y:auto; overflow-X:hidden">
      <el-radio-group v-model="tabPosition" style="margin-bottom: 30px;" size="small" text-color="#ffffff">
        <el-badge :value="item.list.length" class="item"
          v-for="item in $route.path === '/remoteSenseData' ? rsdata : pdata" :key="item.id">
          <el-radio-button @click.native.prevent="onclick(item,item.id)" :label="item.id">{{item.name}}
          </el-radio-button>
        </el-badge>
      </el-radio-group>
    </div>
    <div class="dllist">
      <head-product-list-dialog ref="productList"
        :prodata="$route.path === '/remoteSenseData' ? remotesensedata : productdata" :cartdatas="cartdatas"
        :tcdatas="tcdatas" :moreisvds="moreisvds"
        :msg-father="$route.path === '/remoteSenseData' ? SenseDataListdialogFormVisible : ProductListdialogFormVisible"
        :queryType="queryType" :range="range" :regionname="regionname" :cityId="cityId"
        v-on:getproductdialogFormVisible="getProductDialogMsg" v-on:getselectinfovisible="selectinfo"
        v-on:getcartlist="cartlist" v-on:gettclist="tclist" v-on:moreadd="moreadd">
      </head-product-list-dialog>
      <head-product-content-dialog :prodata="productcontent" :msg-father="ProductContentdialogFormVisible"
        v-on:getproductcontentdialogFormVisible="getProductcontentDialogMsg">
      </head-product-content-dialog>
    </div>
  </div>
</template>
<script>
import HeadProductListDialog from './HeadProductListDialog'
import HeadProductContentDialog from './HeadProductContentDialog'
import Map from '../../common/map/Tmap.js'
import store from '../../vuex/index.js'
export default {
  props: ['msgFather', 'prodata', 'cartdata', 'tcdata', 'map',
    'queryType', 'range', 'regionname', 'cityId', 'regiongeometry'],
  name: 'LeftList',
  components: {
    HeadProductListDialog,
    HeadProductContentDialog
  },
  data () {
    return {
      tabPosition: '1',
      ProductListdialogFormVisible: false,
      SenseDataListdialogFormVisible: false,
      ProductContentdialogFormVisible: false,
      productdata: [],
      remotesensedata: [],
      productcontent: {},
      pdata: [],
      rsdata: [],
      datas: {},
      cartdatas: [],
      tcdatas: [],
      listids: [],
      value5: [],
      value6: [],
      moreisvds: true,
      loading: false
    }
  },
  created () {
    let d = new Date()
    // 设定结束日期为当前日期
    this.value5.push(d)
    this.value6.push(d)
    // 当前设定的日期时间为当前月的第一天
    let year1, month1, day1
    [year1, month1, day1] = [d.getFullYear(), d.getMonth() + 1, d.getDate()]
    this.value5 = year1 + '-' + month1 + '-1 00:00:00'
    this.value6 = year1 + '-' + month1 + '-' + day1 + ' 23:59:59'
    this.datas = this.prodata
    this.cartdatas = this.cartdata
    this.tcdatas = this.tcdata
    this.initdata()
  },
  updated () {
    this.loading = store.state.loading
  },
  methods: {
    addtu (val) {
      this.$refs.productList.addtu(val)
    },
    cartlist: function (val) {
      this.$emit('getcartlists', val)
    },
    tclist: function (val) {
      this.$emit('gettclists', val)
    },
    initdata: function () {
      this.pdata = []
      this.listids = []
      if (JSON.stringify(this.datas) !== '{}') {
        if (this.datas.sdataid.length !== undefined && this.datas.sdataid.length > 0) {
          this.datas.sdataid.forEach((element, index) => {
            if (this.$route.path === '/remoteSenseData' || this.$route.path === '/subscriptionData') {
              this.listids.push(element.code)
            } else {
              this.listids.push(element.id)
            }
          })
          this.initlistinfo()
        } else {
          store.commit('setLoading', false)
          this.ProductListdialogFormVisible = false
          Map.ClearOverSource()
          var message = '请选择产品'
          this.productdata = []
          this.pdata = []
          if (this.$route.path === '/remoteSenseData' || this.$route.path === '/subscriptionData') {
            message = '请选择数据'
            this.remotesensedata = []
            this.rsdata = []
          }
          this.$message({
            message: message,
            type: 'warning'
          })
        }
      }
    },
    initlistinfo: function () {
      store.commit('setLoading', true)
      console.log(this.datas)
      var josndata = {}
      if (this.datas.hours.length > 0) {
        josndata = {
          start_date: this.datas.productstartdate ? this.datas.productstartdate : this.value5,
          end_date: this.datas.productenddate ? this.datas.productenddate : this.value6,
          producttypecode: this.listids,
          producttime: this.datas.hours,
          currentPage: this.datas.currentPage,
          pageSize: this.datas.productpageSize
        }
      } else {
        josndata = {
          start_date: this.datas.productstartdate ? this.datas.productstartdate : this.value5,
          end_date: this.datas.productenddate ? this.datas.productenddate : this.value6,
          producttypecode: this.listids,
          currentPage: this.datas.currentPage,
          pageSize: this.datas.productpageSize
        }
        if (this.$route.path === '/remoteSenseData') {
          let remoteSenseFormData = this.datas.remoteSenseFormData
          if (remoteSenseFormData) {
            josndata['spatial_resolution_min'] = remoteSenseFormData.spatial_resolution_min
            josndata['spatial_resolution_max'] = remoteSenseFormData.spatial_resolution_max
            josndata['sun_elevation_min'] = remoteSenseFormData.sun_elevation_min
            josndata['sun_elevation_max'] = remoteSenseFormData.sun_elevation_max
            josndata['cloud_percent_min'] = remoteSenseFormData.cloud_percent_min
            josndata['cloud_percent_max'] = remoteSenseFormData.cloud_percent_max
            josndata['scene_no'] = remoteSenseFormData.scene_no
          }
          if (this.regiongeometry) {
            josndata['regiongeometry'] = this.regiongeometry
          }
        }
      }
      this.productdata = []
      this.remotesensedata = []
      var url = '/dmc/manage/standardProduct/stdproduct'
      if (this.$route.path === '/remoteSenseData') {
        url = '/dmc/standardSatelliteImage/stdproduct'
        Map.ClearOverSource()
        this.sapost(url, josndata, r => {
          this.rsdata = []
          var arrdata = []
          r.data.forEach((el, index) => {
            if (el.list.length > 0) {
              arrdata.push(el)
            }
          })
          if (arrdata.length <= 0) {
            store.commit('setLoading', false)
            this.$message({
              message: '无查询结果',
              type: 'warning'
            })
            this.SenseDataListdialogFormVisible = false
            return
          }
          this.SenseDataListdialogFormVisible = true
          arrdata.forEach((el, index) => {
            el.list.forEach(ec => {
              ec.checkall = false
              ec.cartcheckall = false
              ec.tccheckall = true
              ec.colorl = [ec.min_value, ec.max_value]
              ec.optionf = 1
              el.id = ec.catalogCode
              el.lname = ec.productDescription
              el.name = ec.productDescription.substring(0, 1)
              el.resolution = parseFloat((parseFloat(ec.spatialResolution).toFixed(6) * parseFloat(ec.spatialResolution).toFixed(6) * 4)).toFixed(6)
              if (index === 0) {
                this.tabPosition = ec.catalogCode
              }
            })
            if (el.list.length > 0) {
              this.rsdata.push(el)
            }
            if (index === 0) {
              this.onclick(el, el.id)
            }
          })
          var ps = ''
          this.rsdata.forEach((element, index) => {
            if (index !== 0) {
              ps += '<span style="margin-left: 10px;">' + element.lname + '</span>'
            } else {
              ps = ' <span>当前选择数据名称：</span>' + '<span style="margin-left: 10px;">' + element.lname + '</span>'
            }
          })
          document.getElementById('footerprotuct').innerHTML = ps
          console.log(this.rsdata)
        })
      } else {
        this.sapost(url, josndata, r => {
          this.pdata = []
          var arrdata = []
          r.data.forEach((el, index) => {
            if (el.list.length > 0) {
              arrdata.push(el)
            }
          })
          if (arrdata.length <= 0) {
            store.commit('setLoading', false)
            this.$message({
              message: '无查询结果',
              type: 'warning'
            })
            this.ProductListdialogFormVisible = false
            return
          }
          this.ProductListdialogFormVisible = true
          arrdata.forEach((el, index) => {
            el.list.forEach(ec => {
              ec.checkall = false
              ec.cartcheckall = false
              ec.tccheckall = true
              ec.colorl = [ec.min_value, ec.max_value]
              ec.optionf = 1
              el.id = ec.catalog_code
              el.lname = ec.product_description
              el.name = ec.product_description.substring(0, 1)
              el.resolution = parseFloat((parseFloat(ec.spatial_resolution).toFixed(6) * parseFloat(ec.spatial_resolution).toFixed(6) * 4)).toFixed(6)
              if (index === 0) {
                this.tabPosition = ec.catalog_code
              }
            })
            if (index === 0) {
              this.onclick(el, el.id)
            }
            if (el.list.length > 0) {
              this.pdata.push(el)
            }
          })
          var ps = ''
          this.pdata.forEach((element, index) => {
            if (index !== 0) {
              ps += '<span style="margin-left: 10px;">' + element.lname + '</span>'
            } else {
              ps = ' <span>当前选择产品名称：</span>' + '<span style="margin-left: 10px;">' + element.lname + '</span>'
            }
          })
          document.getElementById('footerprotuct').innerHTML = ps
          console.log(this.pdata)
        })
      }
      if (this.regiongeometry) {
        Map.AddWKTs2Source(this.regiongeometry, true, 'loading', !this.$route.path === '/remoteSenseData')
      }
    },
    initinfo: function () {
      var josndata = {}
      if (this.datas.hours.length > 0) {
        josndata = {
          start_date: this.datas.productstartdate ? this.datas.productstartdate : this.value5,
          end_date: this.datas.productenddate ? this.datas.productenddate : this.value6,
          producttypecode: this.tabPosition,
          producttime: this.datas.hours,
          currentPage: this.datas.currentPage,
          pageSize: this.datas.productpageSize
        }
      } else {
        josndata = {
          start_date: this.datas.productstartdate ? this.datas.productstartdate : this.value5,
          end_date: this.datas.productenddate ? this.datas.productenddate : this.value6,
          producttypecode: this.tabPosition,
          currentPage: this.datas.currentPage,
          pageSize: this.datas.productpageSize
        }
        if (this.$route.path === '/remoteSenseData') {
          let remoteSenseFormData = this.datas.remoteSenseFormData
          if (remoteSenseFormData) {
            josndata['spatial_resolution_min'] = remoteSenseFormData.spatial_resolution_min
            josndata['spatial_resolution_max'] = remoteSenseFormData.spatial_resolution_max
            josndata['sun_elevation_min'] = remoteSenseFormData.sun_elevation_min
            josndata['sun_elevation_max'] = remoteSenseFormData.sun_elevation_max
            josndata['cloud_percent_min'] = remoteSenseFormData.cloud_percent_min
            josndata['cloud_percent_max'] = remoteSenseFormData.cloud_percent_max
            josndata['scene_no'] = remoteSenseFormData.scene_no
          }
          if (this.regiongeometry) {
            josndata['regiongeometry'] = this.regiongeometry
          }
        }
      }
      Map.ClearOverSource()
      var url = '/dmc/manage/standardProduct/stdproduct'
      if (this.$route.path === '/remoteSenseData') {
        url = '/dmc/standardSatelliteImage/stdproduct'
        this.sapost(url, josndata, r => {
          r.data[0].list.forEach(ec => {
            ec.checkall = false
            ec.cartcheckall = false
            ec.tccheckall = true
            ec.colorl = [ec.min_value, ec.max_value]
            ec.optionf = 100
            if (ec.geometry !== null) {
              Map.AddWKTs2Source(ec.geometry, false, 'data', false)
            }
            let flag = false
            this.remotesensedata.forEach(item => {
              if (item.imageId === ec.imageId) {
                flag = true
              }
            })
            if (!flag) {
              this.remotesensedata.push(ec)
            }
          })
          if (this.regiongeometry) {
            Map.AddWKTs2Source(this.regiongeometry, true, 'geometry', false)
          }
        })
      } else {
        this.sapost(url, josndata, r => {
          r.data[0].list.forEach(ec => {
            ec.checkall = false
            ec.cartcheckall = false
            ec.tccheckall = true
            ec.colorl = [ec.min_value, ec.max_value]
            ec.optionf = 100
            this.productdata.push(ec)
          })
          if (this.regiongeometry) {
            Map.AddWKTs2Source(this.regiongeometry, true, 'geometry', true)
          }
          // this.tcdatas.forEach(item => {
          //   this.productdata.forEach(tag => {
          //     if (item.product_id === tag.product_id) {
          //       tag['itemColor' + tag.product_id] = 'rgb(24, 188, 156)'
          //     }
          //   })
          // })
        })
      }
    },
    selectinfo: function (val) {
      this.productcontent = val.data
      this.ProductContentdialogFormVisible = val.msg
    },
    onclick: function (item, val) {
      // 取消全选状态
      this.$refs.productList.checked = false
      // 隐藏购物车图标
      this.$refs.productList.isshow = false
      if (this.$route.path === '/remoteSenseData') {
        this.remotesensedata = []
        this.SenseDataListdialogFormVisible = true
        Map.changeMapCenter(this.map)
      } else {
        this.productdata = []
        this.ProductListdialogFormVisible = true
      }
      this.datas.currentPage = 1
      var arce = ''
      this.moreisvds = true
      if (item.resolution > 0) {
        arce = item.lname + '起售面积:' + item.resolution
      } else {
        arce = item.lname + '无面积限制'
      }
      document.getElementById('footerarce').innerHTML = arce
      this.tabPosition = val
      if (this.$route.path === '/remoteSenseData') {
        let r = this.rsdata.filter(val => val.id === this.tabPosition)
        r[0].list.forEach(ec => {
          ec.checkall = false
          ec.cartcheckall = false
          ec.tccheckall = true
          ec.colorl = [ec.min_value, ec.max_value]
          ec.optionf = 100
          if (ec.geometry !== null) {
            Map.AddWKTs2Source(ec.geometry, false, 'data', false)
          }
          let flag = false
          this.remotesensedata.forEach(item => {
            if (item.imageId === ec.imageId) {
              flag = true
            }
          })
          if (!flag) {
            this.remotesensedata.push(ec)
          }
        })
        if (this.regiongeometry) {
          Map.AddWKTs2Source(this.regiongeometry, true, 'geometry', false)
        }
      } else {
        this.initinfo()
      }
    },
    getProductcontentDialogMsg: function (msg) {
      this.ProductContentdialogFormVisible = msg
    },
    getProductDialogMsg: function (msg) {
      this.ProductListdialogFormVisible = msg
      if (!this.ProductListdialogFormVisible) {
        this.ProductContentdialogFormVisible = msg
      }
    },
    moreadd: function (msg) {
      this.datas.currentPage = this.datas.currentPage + 1
      if (this.$route.path === '/remoteSenseData') {
        this.rsdata.forEach(item => {
          if (this.tabPosition === item.id) {
            if (this.datas.currentPage === item.pagerSize) {
              this.moreisvds = false
              this.initinfo()
              item.list = this.remotesensedata
            } else {
              this.initinfo()
              item.list = this.remotesensedata
            }
          }
        })
      } else {
        this.pdata.forEach(item => {
          if (this.tabPosition === item.id) {
            if (this.datas.currentPage === item.pagerSize) {
              this.moreisvds = false
              this.initinfo()
              item.list = this.productdata
            } else {
              this.initinfo()
              item.list = this.productdata
            }
          }
        })
      }
    }
  },
  watch: {
    tabPosition: function () {
      console.log('选中')
    },
    prodata: function (val) {
      this.datas = val

      this.initdata()
    },
    regiongeometry (val) {
      if (this.$route.path === '/remoteSenseData') {
        this.initdata()
      }
    },
    // prodata: {
    //   handler(val) {
    //     this.datas = val

    //     this.initdata()
    //   },
    //   deep: true
    // },
    cartdata: function (data) {
      this.cartdatas = data
    },
    tcdata: function (data) {
      this.tcdatas = data
    }
  }
}
</script>
<style>
.dllist {
  height: 100%;
  display: flex;
  justify-content: flex-start;
}
.toolbar-item,
.toolbar-layer {
  background: url(../../assets/images/toolbar.png) no-repeat;
}

.left-toolbar {
  position: fixed;
  left: 0px;
  top: 135px;
  margin-left: 0px;
}
.left-toolbar .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #fff;
  background-color: rgb(28, 180, 150);
  border: 0px;
  -webkit-box-shadow: -1px 0 0 0 rgb(28, 180, 150);
  box-shadow: -1px 0 0 0 rgb(28, 180, 150);
}
.left-toolbar .el-badge__content {
  border-radius: 1px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  padding: 0 6px;
  text-align: center;
  white-space: nowrap;
  border: 0px;
}
.left-toolbar .el-badge__content.is-fixed {
  position: absolute;
  top: 10px;
  right: 24px;
  -webkit-transform: translateY(-50%) translateX(100%);
  transform: translateY(-50%) translateX(100%);
}
.left-toolbar .el-radio-group {
  display: inline-block;
  display: flex;
  justify-content: space-between;
  flex-flow: column;
  line-height: 1;
  vertical-align: middle;
  font-size: 0;
}
.left-toolbar .el-radio-button,
.el-radio-button__inner {
  display: inline-block;
  position: relative;
  outline: 0;
  width: 42px;
  height: 42px;
  margin-top: 5px;
  margin-left: 5px;
}
.left-toolbar .el-radio-button--small .el-radio-button__inner {
  padding: 0px;
  font-size: 12px;
  border-radius: 0;
  border: 0px;
}
.left-toolbar .el-radio-button:first-child .el-radio-button__inner {
  border-left: 0px;
  border-radius: 0px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.left-toolbar .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0px;
}
.left-toolbar .el-radio-button__inner:hover {
  background-color: rgb(28, 203, 150);
}
.left-toolbar .el-radio-button__inner {
  line-height: 3.5;
  white-space: nowrap;
  vertical-align: middle;
  background-color: #191b2e;
  /* border: 1px solid #DCDFE6; */
  font-weight: 500;
  border-left: 0;
  color: #ffffff;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  /* padding: 12px 20px; */
  font-size: 14px;
  border-radius: 0;
}
/*假设网页宽度为1200px，导航条在右侧悬浮*/
.toolbar-item {
  display: block;
  width: 52px;
  height: 52px;
  margin-top: 2px;
  position: relative;
  -moz-transition: background-position 1s;
  -ms-transition: background-position 1s;
  -o-moz-transition: background-position 1s;
  -webkit-moz-transition: background-position 1s;
  transition: background-position 1s;
}

/* .toolbar-item:hover .toolbar-layer {
  opacity: 1;
  filter: alpha(opacity=100);
  transform: scale(1);
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  -o-transform: scale(1);
} */
/* .toolbar-item:hover .toolbar-layer {
  opacity: 1;
  filter: alpha(opacity=100);
  transform: scale(1);
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  -o-transform: scale(1);
} */

.toolbar-item-service {
  background-position: 0 -798px;
}
.toolbar-item-weixin {
  background-position: 0 -798px;
}

.toolbar-item-weixin:hover {
  background-position: 0 -860px;
}

.toolbar-item-weixin .toolbar-layer {
  height: 212px;
  background-position: 0 0;
}

.toolbar-item-feedback {
  background-position: 0 -426px;
}

.toolbar-item-feedback:hover {
  background-position: 0 -488px;
}

.toolbar-item-app {
  background-position: 0 -550px;
}

.toolbar-item-app:hover {
  background-position: 0 -612px;
}

/* .toolbar-item-service:hover {
  background-position: 0 -860px;
} */

.toolbar-item-service .toolbar-layer {
  height: 212px;
  background-position: 0 0;
}

.toolbar-item-feedback {
  background-position: 0 -426px;
}

/* .toolbar-item-feedback:hover {
  background-position: 0 -488px;
} */

.toolbar-item-app {
  background-position: 0 -550px;
}

/* .toolbar-item-app:hover {
  background-position: 0 -612px;
} */

.toolbar-item-app .toolbar-layer {
  height: 194px;
  background-position: 0 -222px;
}
.toolbar-item-top {
  background-position: 0 -674px;
}
.toolbar-item-top1 {
  background-position: 0 -923px;
}
/* .toolbar-item-top1:hover {
  background-position: 0 -986px;
} */
/* .toolbar-item-top:hover {
  background-position: 0 -736px;
} */

.toolbar-layer {
  position: absolute;
  right: 46px;
  bottom: -10px;
  width: 172px;
  opacity: 0;
  filter: alpha(opacity=0);
  transform-origin: 95% 95%;
  -moz-transform-origin: 95% 95%;
  -ms-transform-origin: 95% 95%;
  -o-transform-origin: 95% 95%;
  -webkit-transform-origin: 95% 95%;
  transform: scale(0.01);
  -moz-transform: scale(0.01);
  -ms-transform: scale(0.01);
  -o-transform: scale(0.01);
  -webkit-transform: scale(0.01);
  transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  -webkit-transition: all 1s;
}
</style>



// WEBPACK FOOTER //
// src/components/LeftMenu/LeftList.vue